import { useEffect } from 'react'

const BASE_TITLE = 'INSITE'

const LOCAL_TITLE = '[LOCAL] INSITE'

export function useDocumentTitle(title: string, usePrefix = true) {
  useEffect(() => {
    const isLocalhost = window.location.hostname.includes('localhost')

    const prefix = isLocalhost ? LOCAL_TITLE : BASE_TITLE

    const previousTitle = document.title

    if (usePrefix) {
      const fullTitle = title ? `${prefix} - ${title}` : prefix
      document.title = fullTitle
    } else {
      document.title = title
    }

    return () => {
      document.title = previousTitle
    }
  }, [title, usePrefix])
}
